/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-27 14:50:26
 */ 

const menus = [
    {//首页
        name: ['Index'],
        path: '/',
        component: resolve => require(['@/views/index/index.vue'], resolve),  // 使用懒加载
        meta: {
            title: '微信服务平台',
            scroll: true,
            wxAutherSucc: false,
        }
    },{//微信授权
        name: ['wxAuther'],
        path: '/wxAuther',
        component: resolve => require(['@/views/common/wxAuther.vue'], resolve),
        meta: {
            title: '微信服务平台--微信授权',
        }
    }, { // 获取FFR-CT报告界面
        name: ['FFR报告查询'],
        path: '/queryReport',
        component: resolve => require(['@/views/reporQuery/index.vue'], resolve),
        meta: {
            title: 'FFR-CT冠脉血流分数检测',
            scroll: true,
        }
    }, {//pdf报告显示
        name: ['PDF'],
        path: '/pdf/:id',
        component: resolve => require(['@/views/pdf/index.vue'], resolve),
        meta: {
            title: 'PDF',
            viewport: true,
            scroll: true,
        }
    }, {// 申请检查------信息填写
        name: ['payInfo'],
        path: '/apply/info',
        component: resolve => require(['@/views/applyInspection/fillInfo.vue'], resolve),
        meta: {
            title: '申请检查-填写信息',
            scroll: true,
            login:'wxAuther',//登录过期跳回的登录页
            token: true,//token验证
        }
    }, {// 申请检查------申请成功
        name: ['paySuccess'],
        path: '/apply/paySuccess/:pid',
        component: resolve => require(['@/views/applyInspection/applySuccess.vue'], resolve),
        meta: {
            title: '申请检查-申请成功',
            login:'wxAuther',//登录过期跳回的登录页
            scroll: true,
            token: true,//token验证
        }
    }, { // 个人中心--我的申请 
        name: ['myApply'],
        path: '/my/apply',
        component: resolve => require(['@/views/personalCenter/apply/index.vue'], resolve),
        meta: {
            title: '我的申请',
            type:'myApply',//分组
            login:'myApply',//登录过期跳回的登录页
            // token: true,//token验证
            scroll: true,
        } 
    }, {// 个人中心--我的申请列表
        name: ['myApplyList'],
        path: '/my/apply/list/:id',
        component: resolve => require(['@/views/personalCenter/apply/list.vue'], resolve),
        meta: {
            title: '我的申请-申请列表',
            login:'myApply',//登录过期跳回的登录页
            token: true,//token验证
            type:'myApply',//分组
        }
    }, {// 个人中心--我的申请状态
        name: ['mySchedule'],
        path: '/my/apply/detail/:pid',
        component: resolve => require(['@/views/personalCenter/apply/details.vue'], resolve),
        meta: {
            title: '我的申请-申请状态',
            login:'myApply',//登录过期跳回的登录页
            type:'myApply',//分组
            token: true,//token验证
            scroll: true,
        }
    // }, {
    //     name: ['地图'],
    //     path: '/map/:id',
    //     component: MyMap,
    //     meta: {
    //         title: '地图',
    //         scroll: true,
    //     }
    },
    /**@parms {管理员帐} */ 
    {// 管理员登录
        name: ['ManagerLogin'],
        path: '/manager/login',
        component: resolve => require(['@/views/manager/login.vue'], resolve),
        meta: {
            title: '管理员登录',
            login:'ManagerLogin',//登录过期跳回的登录页
            type:'manager',
            // ticket: true,//token验证
            scroll: true,
        }
    },{// 管理员获取所有病例列表
        name: ['ManagerList'],
        path: '/manager/list',
        component: resolve => require(['@/views/manager/list.vue'], resolve),
        meta: {
            title: '病例管理',
            login:'ManagerLogin',//登录过期跳回的登录页
            type:'manager',
            ticket: true,//token验证
        }
    },{// 管理员获取所有病例列表
        name: ['Consent'],
        path: '/consent',
        component: resolve => require(['@/views/common/Consent.vue'], resolve),
        meta: {
            title: '知情同意书',
            scroll: true,
        }
    },

    


    
]

export default menus


// WEBPACK FOOTER //
// ./src/routes/menu.js